export const linkCodesTranslation = {

  // title
  codetable_administration: 8268,

  // list
  loading: 4501,
  search_hits: 7474,
  search_no_hits: 8309,
  no_access_to_codetable_administration: 8320,
  no_values: 9066,
  validation_error: 8206,

  // details
  codetable: 8651,
  user_group: 8003,
  case_type: 7431,
  type: 8403,
  search: 7345,
  manage_options: 8521,

  // header
  update_codes: 8674,
  show_inactive_codes: 8434,

  // error popup
  codes_update_failed: 8922,
  codes_update_failed_info_text: 8924,
  fix_selections: 8923,
  cancel: 3273,

  // messages
  message_updating: 8677,
  message_codes_updated: 8676,
  message_toggle_off_warning: 9072,

  // items
  disabled: 5251,

  // confirmation prompt
  cancel_changes: 7558,
  are_you_sure: 7460,
  undo_all: 5792,
  go_back: 7966,

  // mark row
  mark_rows: 8907,
  mark_all_selected: 8908,
  mark_all_unselected: 8909,
  mark_highlighted_selected: 8910,
  mark_highlighted_children_selected: 8911,
  mark_highlighted_unselected: 8912,
  visible_all: 8913,
  visible_selected: 8914,
  visible_unselected: 8915,
  visible_show_all: 8916,
  visible_show_selected: 8917,
  visible_show_unselected: 8918
};

export type LinkCodesTranslation = {
  readonly [T in keyof typeof linkCodesTranslation]: string
};

export const linkCodesAction = {
  select: 'select',
  deselect: 'deselect',
  selectAll: 'select_all',
  deselectAll: 'deselect_all'
} as const;

export type LinkCodesActionType = typeof linkCodesAction[keyof typeof linkCodesAction];

export const defaultMaxResults = 50;
